import { useIntl } from 'react-intl';
import { constraintConfig } from '../../../../constraintConfig';
import { selectAuth } from '../../../../features/authSlice';
import { useAppSelector } from '../../../../hooks';
import { MenuInnerWithSub } from './MenuInnerWithSub';
import { MenuItem } from './MenuItem';
import { SettingsMegaMenu } from './SettingsMegaMenu';
import { allRoutes } from '../../../../app/routing/All_Routes';
import { useGetAllPendingRequestedUserQuery } from '../../../../services/DraftApi';
import { getAllReceiptsPageTitle } from '../../../../app/pages/Invoices/allReceiptsActionHelpers';
import labelKey from '../../../../app/localization/label.json';


export function MenuInner() {
  const {
    roleID,
    reportPermision,
    userPermission,
    isOrgUserImpersonate,
    isReceiptVaultLineItemsVersion,
    isSurveysModuleEnabled,
    isExpenseAnomaliesModuleEnabled,
  } = useAppSelector(selectAuth);
  const { data: pendingUserRequestCount, isFetching: isLoading, isSuccess, refetch } = useGetAllPendingRequestedUserQuery('')

  const intl = useIntl()
  const allReceiptsTitle = getAllReceiptsPageTitle(roleID);
  // OrgSetting IsReceiptVaultLineItemsVersion: v1 → /receipt-vault, v2 → /allreceipts
  const receiptVaultVersion = String(isReceiptVaultLineItemsVersion || 'v2').toLowerCase()
  const showReceiptVaultV1Menu = receiptVaultVersion === 'v1' || receiptVaultVersion === '1'
  const showReceiptVaultV2Menu = !showReceiptVaultV1Menu
  return (
    <>
      {(roleID !== constraintConfig.roleID.role10 && roleID !== constraintConfig.roleID.roleIDPortalSupport && roleID !== constraintConfig.roleID.roleExecutive) && (
        <MenuItem title={intl.formatMessage({ id: 'MENU.DASHBOARD' })} to='/dashboard' />
      )}
      {(roleID === constraintConfig.roleID.role10) && (
        <MenuItem title='Expense Approval' to='/ap-approved' />
      )}

      {/* Impersonate User - Show to all users EXCEPT super admin (role1) */}
      {(isOrgUserImpersonate === true) && (
        <MenuItem title='Impersonate User' to={allRoutes.impersonateUser} />
      )}
      {(roleID === constraintConfig.roleID.role4 || roleID === constraintConfig.roleID.role5) && (
        <>
          <MenuItem title='Expense Wizard' to={allRoutes.expenseWizard} />
          <MenuItem title='Expense Line Items' to='/expense-line-items' />
          <MenuItem title='Expense Reports' to={allRoutes.expenseReports} />
          {showReceiptVaultV1Menu && (
            <MenuItem title={labelKey.receiptVault} to='/receipt-vault' />
          )}
          {showReceiptVaultV2Menu && (
            <MenuItem title={allReceiptsTitle} to='/allreceipts' />
          )}
        </>
      )}
      {(roleID === constraintConfig.roleID.role5) && (
        <>
          <MenuItem title='My Budget History' to='/budget-history' />
        </>
      )}

      {(roleID === constraintConfig.roleID.roleIDAdmin || roleID === constraintConfig.roleID.role4 || roleID === constraintConfig.roleID.roleExecutive) && (
        <MenuItem title='Expense Approval Queue' to='/approval-queue' />
      )}
      {(roleID === constraintConfig.roleID.role4) && (
        <>
          <MenuItem title='Team Management' to='/team-management' badgeCount={pendingUserRequestCount?.result} badgeColor="danger" />
          {/* <MenuItem title='Backup Approvers' to={allRoutes.backupApprovers} /> */}
        </>
      )}
      {(roleID === constraintConfig.roleID.role4 || roleID === constraintConfig.roleID.role5 || roleID === constraintConfig.roleID.role2 || roleID === constraintConfig.roleID.roleIDAdmin) && (
        <MenuItem title='Cards' to='/card' />
      )}
      {(roleID === constraintConfig.roleID.role2 || roleID === constraintConfig.roleID.roleIDAdmin || reportPermision === true) && (
        <>
          <MenuItem title='Search Expenses' to={allRoutes.searchExpense} />
        </>
      )}
      {/* {(roleID === constraintConfig.roleID.role4 || roleID === constraintConfig.roleID.role2) && (
        <MenuItem title='Vendor' to='/vendor' />
      )} */}
      {roleID === constraintConfig.roleID.role4 ? (
        // <MenuItem title='Report Analytics' to={`${allRoutes.analytics}' />
        <>
          <MenuInnerWithSub
            title='Analytics'
            to={allRoutes.analytics}
            // icon='/media/icons/duotune/communication/com006.svg'
            // hasArrow={true}
            menuPlacement='bottom-start'
            menuTrigger={`{default:'click', lg: 'hover'}`}
          >
            <MenuItem to={`${allRoutes.analytics}/my-report/expense-summary`} title='My Reports' hasBullet={true} />
            <MenuItem to={`${allRoutes.analytics}/team-report/expense-summary`} title='Team Reports' hasBullet={true} />
            {reportPermision === true &&
              <>
                {roleID === constraintConfig.roleID.role4 &&
                  <MenuItem to={`${allRoutes.analytics}/org-report/expense-summary`} title='Org Reports' hasBullet={true} />
                }
              </>
            }
          </MenuInnerWithSub>
        </>
      ) : null}
      {roleID === constraintConfig.roleID.role5 &&
        <MenuItem title='Analytics' to={`${allRoutes.analytics}/my-report/expense-summary`} />
      }
      {/* {reportPermision === true &&
        <>
          {roleID === constraintConfig.roleID.role10 &&
            <MenuItem title='Analytics' to={`${allRoutes.analytics}/org-report/expense-summary`} />
          }
        </>
      } */}
      {(roleID === constraintConfig.roleID.role2 || roleID === constraintConfig.roleID.roleIDAdmin || (reportPermision === true && roleID === constraintConfig.roleID.role10)) && (
        <MenuItem
          to={`${allRoutes.analytics}/org-report/expense-summary`}
          title='Analytics'
        />
      )}

      {/* {(roleID === constraintConfig.roleID.role2) && (
        <MenuItem title='Workflow' to='/workflow' />
      )} */}


      {/* {(roleID === constraintConfig.roleID.role2) && (
        <MenuItem title='Manager Expense' to='/approvers' />
      )} */}

      {/* <MenuInnerWithSub title='Workflow' to='/workflow' menuPlacement='bottom-start' menuTrigger='click'>
        <MenuItem
          icon='/media/icons/duotune/general/gen051.svg'
          to='/workflow/workflow'
          title='Workflow'
        />
        <MenuItem
          icon='/media/icons/duotune/general/gen051.svg'
          to='/workflow/approvers'
          title='Approvers'
        />
      </MenuInnerWithSub> */}

      {
        (roleID === constraintConfig.roleID.role1) && (
          <MenuItem title='Organizations' to='/organization' />
        )
      }
      {
        (roleID === constraintConfig.roleID.role1) && (
          <MenuInnerWithSub
            title='Settings'
            to='/settings'
            menuPlacement='bottom-start'
            menuTrigger='click'
            isMega={true}
            megaClassName='ss-settings-mega-dropdown menu-rounded-0 p-0'
            keepOpenOnInsideClick={true}
            menuOverflow={true}
          >
            <SettingsMegaMenu
              variant='superAdmin'
              roleID={roleID}
              isSurveysModuleEnabled={isSurveysModuleEnabled}
              isExpenseAnomaliesModuleEnabled={isExpenseAnomaliesModuleEnabled}
            />
          </MenuInnerWithSub>
        )
      }
      {
        (roleID === constraintConfig.roleID.role1 || roleID === constraintConfig.roleID.role2 || roleID === constraintConfig.roleID.roleIDAdmin || roleID === constraintConfig.roleID.roleExecutive) &&
        <>
          <MenuItem title={roleID === constraintConfig.roleID.role2 || roleID === constraintConfig.roleID.roleIDAdmin || roleID === constraintConfig.roleID.roleExecutive ? 'Expense Users' : "Admin Users"} to='/expense-users' />
        </>
      }
      {
        (roleID === constraintConfig.roleID.role1) && (
          <MenuItem title='Roles' to='/roles' />
        )
      }
      {
        (roleID === constraintConfig.roleID.role1 ||
          roleID === constraintConfig.roleID.role2 ||
          roleID === constraintConfig.roleID.roleIDAdmin ||
          roleID === constraintConfig.roleID.roleIDPortalSupport) && (
          <>
            {showReceiptVaultV1Menu && (
              <MenuItem to='/receipt-vault' title={labelKey.receiptVault} />
            )}
            {showReceiptVaultV2Menu && (
              <MenuItem to='/allreceipts' title={allReceiptsTitle} />
            )}
          </>
        )
      }
      {
        (roleID === constraintConfig.roleID.role2 || roleID === constraintConfig.roleID.roleIDAdmin) && (
          <>
            <MenuInnerWithSub
              title='Settings'
              to='/settings'
              menuPlacement='bottom-start'
              menuTrigger='click'
              isMega={true}
              megaClassName='ss-settings-mega-dropdown menu-rounded-0 p-0'
              keepOpenOnInsideClick={true}
              menuOverflow={true}
            >
              <SettingsMegaMenu
                variant='orgAdmin'
                roleID={roleID}
                isSurveysModuleEnabled={isSurveysModuleEnabled}
                isExpenseAnomaliesModuleEnabled={isExpenseAnomaliesModuleEnabled}
              />
            </MenuInnerWithSub>
          </>
        )
      }
      {
        (roleID === constraintConfig.roleID.role2 || roleID === constraintConfig.roleID.roleIDAdmin || roleID === constraintConfig.roleID.roleIDPortalSupport) && (
          <MenuItem to='/portal-support-requests' title='Portal Support Requests' />
        )
      }

      {
        (roleID === constraintConfig.roleID.role4 || (roleID === constraintConfig.roleID.roleExecutive && userPermission && userPermission.length > 0)) && (
          <>
            <MenuInnerWithSub
              title='Budget Allocation'
              to='/budget-allocation'
              // icon='/media/icons/duotune/communication/com006.svg'
              // hasArrow={true}
              menuPlacement='bottom-start'
              menuTrigger={`{default:'click', lg: 'hover'}`}
            >
              {roleID !== constraintConfig.roleID.roleExecutive &&
                <MenuItem to='/budget-allocation/budget-history' title='My Budget History' hasBullet={true} />
              }
              {/* {userPermission. === constraintConfig.lst_PermissionIds.flexBudgetPermissionId && */}
              {userPermission?.some((permission: any) =>
                permission.lst_PermissionId === constraintConfig.lst_PermissionIds.flexBudgetPermissionId) &&
                <MenuItem to='/budget-allocation/budgets' title='User Flex Budget' hasBullet={true} />
              }
              {userPermission?.some((permission: any) =>
                permission.lst_PermissionId === constraintConfig.lst_PermissionIds.categoryBudgetPermissionId) &&
                <MenuItem to='/budget-allocation/category-budgeting' title='Category Budget Allocation' hasBullet={true} />
              }
            </MenuInnerWithSub>
          </>
        )
      }

      {/* <MenuItem title='Google Map' to='/map' /> */}

      {/* <MenuItem title='Layout Builder' to='/builder' /> */}



      {/* <MenuInnerWithSub
        title='Crafted'
        to='/crafted'
        menuPlacement='bottom-start'
        menuTrigger='click'
      >
        <MenuInnerWithSub
          title='Pages'
          to='/crafted/pages'
          icon='/media/icons/duotune/general/gen022.svg'
          hasArrow={true}
          menuPlacement='right-start'
          menuTrigger={`{default:'click', lg: 'hover'}`}
        >
          <MenuInnerWithSub
            title='Profile'
            to='/crafted/pages/profile'
            hasArrow={true}
            hasBullet={true}
            menuPlacement='right-start'
            menuTrigger={`{default:'click', lg: 'hover'}`}
          >
            <MenuItem to='/crafted/pages/profile/overview' title='Overview' hasBullet={true} />
            <MenuItem to='/crafted/pages/profile/projects' title='Projects' hasBullet={true} />
            <MenuItem to='/crafted/pages/profile/campaigns' title='Campaigns' hasBullet={true} />
            <MenuItem to='/crafted/pages/profile/documents' title='Documents' hasBullet={true} />
            <MenuItem
              to='/crafted/pages/profile/connections'
              title='Connections'
              hasBullet={true}
            />
          </MenuInnerWithSub>
          <MenuInnerWithSub
            title='Wizards'
            to='/crafted/pages/wizards'
            hasArrow={true}
            hasBullet={true}
            menuPlacement='right-start'
            menuTrigger={`{default:'click', lg: 'hover'}`}
          >
            <MenuItem to='/crafted/pages/wizards/horizontal' title='Horizontal' hasBullet={true} />
            <MenuItem to='/crafted/pages/wizards/vertical' title='Vertical' hasBullet={true} />
          </MenuInnerWithSub>
        </MenuInnerWithSub>

        <MenuInnerWithSub
          title='Accounts'
          to='/crafted/accounts'
          icon='/media/icons/duotune/communication/com006.svg'
          hasArrow={true}
          menuPlacement='right-start'
          menuTrigger={`{default:'click', lg: 'hover'}`}
        >
          <MenuItem to='/crafted/account/overview' title='Overview' hasBullet={true} />
          <MenuItem to='/crafted/account/settings' title='Settings' hasBullet={true} />
        </MenuInnerWithSub>

        <MenuInnerWithSub
          title='Errors'
          to='/error'
          icon='/media/icons/duotune/technology/teh004.svg'
          hasArrow={true}
          menuPlacement='right-start'
          menuTrigger={`{default:'click', lg: 'hover'}`}
        >
          <MenuItem to='/error/404' title='Error 404' hasBullet={true} />
          <MenuItem to='/error/500' title='Error 500' hasBullet={true} />
        </MenuInnerWithSub>

        <MenuInnerWithSub
          title='Widgets'
          to='/crafted/widgets'
          icon='/media/icons/duotune/general/gen025.svg'
          hasArrow={true}
          menuPlacement='right-start'
          menuTrigger={`{default:'click', lg: 'hover'}`}
        >
          <MenuItem to='/crafted/widgets/lists' title='Lists' hasBullet={true} />
          <MenuItem to='/crafted/widgets/statistics' title='Statistics' hasBullet={true} />
          <MenuItem to='/crafted/widgets/charts' title='Charts' hasBullet={true} />
          <MenuItem to='/crafted/widgets/mixed' title='Mixed' hasBullet={true} />
          <MenuItem to='/crafted/widgets/tables' title='Tables' hasBullet={true} />
          <MenuItem to='/crafted/widgets/feeds' title='Feeds' hasBullet={true} />
        </MenuInnerWithSub>
      </MenuInnerWithSub> */}

      {/* <MenuInnerWithSub title='Apps' to='/apps' menuPlacement='bottom-start' menuTrigger='click'>
      
        <MenuInnerWithSub
          title='Chat'
          to='/apps/chat'
          icon='/media/icons/duotune/communication/com012.svg'
          hasArrow={true}
          menuPlacement='right-start'
          menuTrigger={`{default:'click', lg: 'hover'}`}
        >
          <MenuItem to='/apps/chat/private-chat' title='Private Chat' hasBullet={true} />
          <MenuItem to='/apps/chat/group-chat' title='Group Chart' hasBullet={true} />
          <MenuItem to='/apps/chat/drawer-chat' title='Drawer Chart' hasBullet={true} />
        </MenuInnerWithSub>
        <MenuItem
          icon='/media/icons/duotune/general/gen051.svg'
          to='/apps/user-management/users'
          title='User management'
        />
      </MenuInnerWithSub> */}
      {/* <MenuInnerWithSub
        isMega={true}
        title='Mega menu'
        to='/mega-menu'
        menuPlacement='bottom-start'
        menuTrigger='click'
      >
        <MegaMenu />
      </MenuInnerWithSub> */}
    </>
  )
}
